import type { FieldErrors, FieldValues } from "react-hook-form";
import type { FormFieldData } from "../Controllers/FormFieldController";
import { hasNestedValue } from "./hasNestedValue";

export function countErrorsForTab(
  tabId: string,
  formFieldData: FormFieldData<FieldValues>,
  errors: FieldErrors<FieldValues>
) {
  return Object.values(formFieldData)
    .filter((field) => field && field.group === tabId)
    .filter((field) => {
      if (!field) return false;
      return hasNestedValue(errors, field.name);
    }).length;
}
